import { createAsyncThunk } from '@reduxjs/toolkit';
import CommonEnumsResource from 'api/service/CommonEnumsResource';

export const listTypes = createAsyncThunk('properties/listTypes', async () => {
  const commonEnumsResource = new CommonEnumsResource();
  const { status, data } = await commonEnumsResource.list('property_type');
  if (status === 200) {
    return data;
  }
  return [];
});
